/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgStar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      d='M5.99994 0.420044C6.29683 0.420044 6.56797 0.58858 6.69938 0.854797L8.00127 3.49229L10.9128 3.91784C11.2065 3.96078 11.4504 4.1667 11.5419 4.44907C11.6335 4.73143 11.5568 5.04129 11.3442 5.2484L9.23807 7.29975L9.73512 10.1978C9.78531 10.4904 9.665 10.7862 9.42478 10.9607C9.18455 11.1352 8.86609 11.1582 8.60329 11.02L5.99994 9.65092L3.3966 11.02C3.1338 11.1582 2.81533 11.1352 2.57511 10.9607C2.33489 10.7862 2.21458 10.4904 2.26477 10.1978L2.76182 7.29975L0.655713 5.2484C0.443071 5.04129 0.366418 4.73143 0.457973 4.44907C0.549527 4.1667 0.793418 3.96078 1.08713 3.91784L3.99862 3.49229L5.30051 0.854797C5.43192 0.58858 5.70306 0.420044 5.99994 0.420044Z'
      fill='currentColor'
      fillOpacity={0.64}
    />
  </svg>
)
export default SvgStar
